<template>
    <div class="content-box">
        搜索历史：
        <Link v-for="item in workSearchHistory" :href="route('work.index', {search: item})" :key="item"
              class="link-search">{{ item }}
        </Link>
    </div>
</template>

<script setup lang="ts">
import Link from "@/Components/Link.vue";
import {computed, ref} from "vue";
import {route} from "@/utils/common";
import {useStore} from "@/utils/store";

const history = ref<string[]>([])
const store = useStore()
const workSearchHistory = computed(() => store.localState.workSearchHistory)

</script>

<style scoped lang="less">
.content-box {
    .link-search {
        margin-right: 10px;
    }
}
</style>
